// Página viva do design system (docs/ai/design-system). Só existe no build de
// desenvolvimento: em produção/homologação o array fica vazio e a rota não entra no bundle.
const routes = process.env.NODE_ENV === 'development'
    ? [
        {
            path: '/design-system',
            component: () => import('@/shared/components/layout/Interno'),
            children: [
                {
                    name: 'DesignSystem',
                    path: '/',
                    component: () => import('../views/DesignSystem')
                }
            ]
        }
    ]
    : []

export default routes
